import Path from '../../../services/paths'
import utils from '../../common/utils'
import ProductAction from '../../prat_actions/gt/productAction'
import CustomToast from '../../../util-functions/customToast.jsx'

export default class PromotionMiddleware {
    static get_devisions() {
        return dispatch => {
            try{
            dispatch(ProductAction.productDevisions_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_PRODUCT_DEVISION, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {

                            dispatch(ProductAction.productDevisions_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productDevisions_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productDevisions_Failed(err.message))

                })
            }
            catch(err) {console.error(err.message)}
        }
    };

    // promotion level

    //---------for customer
    static get_customers() {
        return dispatch => {
            dispatch(ProductAction.productCustomer_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_PRODUCT_CUSTOMER, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.productCustomer_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productCustomer_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productCustomer_Failed(err.message))

                })
        }
    };
    //---------for customer

    static get_sbb_type(){
    //    const csrftoken = getCookie('csrftoken');
       return dispatch => {
           dispatch(ProductAction.sbb_type_Request());
           utils.get_token()
           .then(token => {
        // ToastsStore.success("status")
               fetch(`${Path.BASE_URL}/sbb_type/` , {
                   method: 'GET',
                   headers: {
                       "Content-type": "application/json",
                       Authorization: `Bearer ${token}`,
                    //    'X-CSRFToken': csrftoken
                   }
               })
               .then(res => res.json())
               .then(data => {
                   if(Array.isArray(data)){

                       dispatch(ProductAction.sbb_type_Success(data))
                   }
                   else{
                       let arr = [];
                       dispatch(ProductAction.sbb_type_Success(arr))
                   }
               })
               .catch(err => {
                   dispatch(ProductAction.sbb_type_Failed(err.message))
               })
           })
           .catch(err => {
               dispatch(ProductAction.sbb_type_Failed(err.message))

           })
       }
   };
    static get_categories(isIC) {
        let url = `${Path.GET_PRODUCT_CATEGORY}?`;

        if ((isIC !== undefined) && (isIC || !isIC)) {
            url += `is_ic=${isIC}&`;
        }

        url = url.slice(0, -1);
        return dispatch => {
            dispatch(ProductAction.productCategories_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.productCategories_Success(data))
                        })
                        .catch(err => {
                            if(err.message === 'Failed to fetch'){
                                CustomToast('warning', 'Please check your internet connection')
                            }
                            dispatch(ProductAction.productCategories_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productCategories_Failed(err.message))

                })
        }
    };

    static get_brands() {
        return dispatch => {
            dispatch(ProductAction.productBrands_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_PRODUCT_BRAND, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.detail === "Authentication credentials were not provided.") {
                                localStorage.clear();
                                window.location.reload();
                              }
                            dispatch(ProductAction.productBrands_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productBrands_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productBrands_Failed(err.message))

                })
        };
    };

    static get_skus() {
        return dispatch => {
            dispatch(ProductAction.productSkus_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_PRODUCT_SKU, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.productSkus_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productSkus_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productSkus_Failed(err.message))

                })
        }
    };

    static get_master_skus() {
        return dispatch => {
            dispatch(ProductAction.product_Master_Skus_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_PRODUCT_MASTER_SKU, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.product_Master_Skus_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.product_Master_Skus_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.product_Master_Skus_Failed(err.message))

                })
        }
    };
    static getCategories_onVariants(data,formats,size){
     let url = `${Path.GET_PRODUCT_CATEGORY}?`
     data&& data.forEach((e,index) => {
        // index===data.length-1 ?
        // url += `variant=${e}`
        //  :
        url += `_variant=${e}&`

    //   setTimeout(() => {
        //   }, 10);
    })
        formats&&formats.forEach((item,ind)=> {
            // ind===formats.length-1 ?
            // url += `format=${item}`
            // :
            url += `_format=${item}&`
        })
        size&&size.forEach((item,ind)=> {
            ind===size.length-1 ?
            url += `_size=${item}`
            :
            url += `_size=${item}&`
        })
        return dispatch => {
            dispatch(ProductAction.productCategories_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            if(!Array.isArray(data)){
                                // ToastsStore.error("Detail not found");
                                CustomToast('error', 'Detail not found')
                                dispatch(ProductAction.productCategories_Failed(data))

                            } else{
                            dispatch(ProductAction.productCategories_Success(data))
                            }
                        })
                        .catch(err => {
                            dispatch(ProductAction.productCategories_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productCategories_Failed(err.message))

                })
        }
    }
    static getBrands_onVariants(data,formats,size){
     let url = `${Path.GET_PRODUCT_BRAND}?`
     data&& data.forEach((e,index) => {
        // index===data.length-1 ?
        // url += `variant=${e}`
        //  :
        url += `_variant=${e}&`

    })
            formats&&formats.forEach((item,ind)=> {
            //     ind===formats.length-1 ?
            //    url += `format=${item}`
            //     :
               url += `_format=${item}&`
           })
           size&&size.forEach((item,ind)=> {
            ind===size.length-1 ?
            url += `_size=${item}`
            :
            url += `_size=${item}&`
        })
        return dispatch => {
            // dispatch(ProductAction.productVariants_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            if(!Array.isArray(data)){
                                // ToastsStore.error("Detail not found");
                                CustomToast('error', 'Detail not found')
                                dispatch(ProductAction.productBrands_Failed(data))

                            } else{
                            dispatch(ProductAction.productBrands_Success(data))
                            }
                        })
                        .catch(err => {
                            dispatch(ProductAction.productBrands_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productBrands_Failed (err.message))

                })
        }
    }
    static getMasterSkus_onVariants(data,formats,size){
     let url = `${Path.GET_PRODUCT_MASTER_SKU}?`
     data&& data.forEach((e,index) => {
        // index===data.length-1 ?
        // url += `variant=${e}`
        //  :
        url += `_variant=${e}&`

    })
            formats&&formats.forEach((item,ind)=> {
            //     ind===formats.length-1 ?
            //    url += `format=${item}`
            //     :
               url += `_format=${item}&`
           })
           size&&size.forEach((item,ind)=> {
            ind===size.length-1 ?
            url += `_size=${item}`
            :
            url += `_size=${item}&`
        })
        return dispatch => {
            dispatch(ProductAction.product_Master_Skus_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            if(Array.isArray(data)){
                                dispatch(ProductAction.product_Master_Skus_Success(data))
                            }else {
                                let obj = Object.entries(data);
                                obj.forEach(([key,value]) => {
                                    // ToastsStore.error(key,value)
                                CustomToast('error', value)
                                })
                            }
                        })
                        .catch(err => {
                            dispatch(ProductAction.product_Master_Skus_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.product_Master_Skus_Failed(err.message))

                })
        }
    }
    static getSkus_onVariants(data,formats,size){
     let url = `${Path.GET_PRODUCT_SKU}?`
     data&& data.forEach((e,index) => {
        // index===data.length-1 ?
        // url += `variant=${e}`
        //  :
        url += `_variant=${e}&`

        
    })
            formats&&formats.forEach((item,ind)=> {
            //     ind===formats.length-1 ?
            //    url += `format=${item}`
            //     :
               url += `_format=${item}&`
           })
           size&&size.forEach((item,ind)=> {
            ind===size.length-1 ?
            url += `_size=${item}`
            :
            url += `_size=${item}&`
        })
        return dispatch => {
            dispatch(ProductAction.productSkus_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            if(!Array.isArray(data)){
                                // ToastsStore.error('detail not found')
                                CustomToast('error', 'detail not found')
                                dispatch(ProductAction.productSkus_Failed(data))
                            } else{
                                dispatch(ProductAction.productSkus_Success(data))
                            }
                        })
                        .catch(err => {
                            dispatch(ProductAction.productSkus_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productSkus_Failed(err.message))

                })
        }
    }
    //size fixed
    static get_variants(data) {
        
        let url = `${Path.GET_PRODUCT_VARIANTS}?productable_level=${data?.level}`
        data&& data._ids.forEach(e => {
            url += `&productable_id=${e}`
        })
        return dispatch => {
            dispatch(ProductAction.productVariants_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.productVariants_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productVariants_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productVariants_Failed(err.message))

                })
        }
    };

    static get_formats(data) {
        let url = `${Path.GET_PRODUCT_FORMATS}?`

        if(data?.level){
            url += `productable_level=${data.level}&`
        }

        data&& data._ids.forEach(e => {
            url += `productable_id=${e}&`
        })
        
        url = url.slice(0, -1);

        return dispatch => {
            dispatch(ProductAction.productFormats_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.productFormats_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productFormats_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productFormats_Failed(err.message))

                })
        }
    };

    //PRODUCT SIZE 
    static get_size(data) {
        let url = `${Path.GET_PRODUCT_SIZE}?productable_level=${data?.level}`
        data&& data._ids.forEach(e => {
            url += `&productable_id=${e}`
        })
        return dispatch => {
            dispatch(ProductAction.productSize_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.productSize_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productSize_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productSize_Failed(err.message))

                })
        }
    };


    //ACTIVITY END STOCK

    static get_activity_end_stock(page,
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus,
        selectedProductSkus,
        selectedProductVariants,
        selectedProductFormats
    ) {
       
        let url = `${Path.GET_ACTIVITY_END_STOCK}?`;

        if (Array.isArray(selectedProductCategories)) {
            selectedProductCategories.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedProductBrands)) {
            selectedProductBrands.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedProductMasterSkus)) {
            selectedProductMasterSkus.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }

        if (Array.isArray(selectedProductSkus)) {
            selectedProductSkus.forEach(element => {
                url += `sku=${element}&`;
            });
        }
        if (Array.isArray(selectedProductFormats)) {
            selectedProductFormats.forEach(element => {
                url += `sku_format=${element}&`;
            });
        }
        if (Array.isArray(selectedProductVariants)) {
            selectedProductVariants.forEach(element => {
                url += `sku_variant=${element}&`;
            });
        }

        if (page) {
            url += `page=${page}&`;
        }
        url = url.slice(0, -1);
        return dispatch => {
            dispatch(ProductAction.activityEndStock_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(ProductAction.activityEndStock_Success(data, page))
                        })
                        .catch(err => {
                            dispatch(ProductAction.activityEndStock_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.activityEndStock_Failed(err.message))

                })
        }
    };

    static get_sectors(msku) {
        let url = `${Path.GET_PRODUCT_SECTORS}`;
        
        return dispatch => {
            dispatch(ProductAction.productSectors_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.detail === "Authentication credentials were not provided.") {
                                localStorage.clear();
                                window.location.reload();
                              }
                            dispatch(ProductAction.productSectors_Success(data))
                        })
                        .catch(err => {
                            dispatch(ProductAction.productSectors_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(ProductAction.productSectors_Failed(err.message))

                })
        };
    };
}

